export * from './bmi.module';
